import React, { useState } from 'react';

/**
 * Segmented Control - iOS-style toggle bar for 2-5 options.
 *
 * Best for short ordinal scales, yes/no variants, or small categorical choices.
 * Renders as a single connected bar with segments that highlight on selection.
 *
 * Usage: responseConfig.layout = 'segmented'
 */
const SegmentedControl = ({
  options = [],
  value = null,
  onChange,
  disabled = false,
  activeColor = '#0d9488',
  inactiveColor = '#f1f5f9',
  activeTextColor = '#ffffff',
  inactiveTextColor = '#334155',
  fontSize = 14,
  height = 44,
  borderRadius = 8,
  className = '',
}) => {
  const [selectedValue, setSelectedValue] = useState(value);

  const handleSelect = (val) => {
    if (disabled) return;
    setSelectedValue(val);
    if (onChange) onChange(val);
  };

  if (!options.length) return null;

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        backgroundColor: inactiveColor,
        borderRadius,
        border: '1px solid #e2e8f0',
        overflow: 'hidden',
        width: '100%',
        height,
      }}
    >
      {options.map((opt, i) => {
        const optValue = typeof opt === 'object' ? opt.value : opt;
        const optLabel = typeof opt === 'object' ? opt.label : opt;
        const isSelected = String(selectedValue) === String(optValue);

        return (
          <button
            key={i}
            onClick={() => handleSelect(optValue)}
            disabled={disabled}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: isSelected ? activeColor : 'transparent',
              color: isSelected ? activeTextColor : inactiveTextColor,
              fontSize,
              fontWeight: isSelected ? '600' : '400',
              fontFamily: 'system-ui, sans-serif',
              border: 'none',
              borderRight: i < options.length - 1 ? '1px solid #e2e8f0' : 'none',
              cursor: disabled ? 'default' : 'pointer',
              transition: 'all 0.15s ease',
              padding: '0 8px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {optLabel}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
